import { inject, Injectable, signal } from '@angular/core';
import { TaskManagementApis } from '../../../services/taskManagement';

export type AlertPriority = 'HIGH' | 'MEDIUM' | 'LOW';

export interface AlertItem {
  id: number;
  title: string;
  priority: AlertPriority;
  code_group: string;
  object_links: { id?: number; object: string; object_id: number; label: string; on_click?: string }[];
  created_at: string;
}

@Injectable({ providedIn: 'root' })
export class AlertsMarqueeService {
  private tasks = inject(TaskManagementApis);

  private _alerts = signal<AlertItem[]>([]);
  readonly alerts = this._alerts.asReadonly();

  private _totalCount = signal<number>(0);
  readonly totalCount = this._totalCount.asReadonly();

  private _lastUpdated = signal<number | null>(null);
  readonly lastUpdated = this._lastUpdated.asReadonly();

  private _loading = signal<boolean>(false);
  readonly loading = this._loading.asReadonly();

  loadAlerts(): void {
    this._loading.set(true);
    this.tasks.getAlerts({ pageNo: 1, pageSize: 10, priority: 'HIGH' }).subscribe({
      next: (res) => {
        const list = res?.response?.list ?? res?.response?.alerts ?? res?.response ?? [];
        const dataFilter = res?.response?.dataFilter;
        const mapped = (Array.isArray(list) ? list : []).slice(0, 10).map(
          (a: any) =>
            ({
              id: a?.id,
              title: a?.title,
              priority: a?.priority,
              code_group: a?.auto_code_group ?? a?.code_group,
              object_links: Array.isArray(a?.object_links) ? a.object_links : [],
              created_at: a?.created_at ?? a?.updated_at ?? a?.due_at,
            }) as AlertItem
        );
        this._alerts.set(mapped);
        this._totalCount.set(dataFilter?.totalCount ?? mapped.length);
        this._lastUpdated.set(Date.now());
        this._loading.set(false);
      },
      error: () => {
        this._loading.set(false);
      },
    });
  }

  setAlerts(alerts: AlertItem[]): void {
    this._alerts.set(alerts ?? []);
  }

  refresh(): void {
    this.loadAlerts();
  }
}
